import React from 'react';
import OfferDetailsInModal from './OfferDetailsInModal';
import BidForm from './BidForm';
// import Modal from '../Components/Modal';
import { getToken } from '../utils';

function ModalBuyorSellTransaction({ content }) {
  const { offerDetails, setBidData, handleOpenandCloseModal, bidData } =
    content;
  const userId = getToken()?.user?.id;

  const handleSubmitBid = (e) => {
    e.preventDefault();

    handleOpenandCloseModal('bid');
  };

  return (
    <section
      className={`bg-white max-h-[510px] overflow-auto ${
        offerDetails?.originator?.id === userId
          ? 'max-w-lg'
          : 'grid md:grid-cols-5 max-w-[850px]'
      } items-center mx-auto w-full  drop-shadow-2xl rounded-lg absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2`}
    >
      {offerDetails?.originator?.id !== userId && (
        <div className='col-span-5 md:col-span-2 gap-10 h-full w-full box-border bg-t-wh p-2 py-8 sm:p-8 md:p-6 lg:p-8'>
          <BidForm
            content={{
              offerDetails,
              setBidData,
              handleSubmitBid,
              bidData,
            }}
          />
        </div>
      )}

      <div className='w-full p-2 py-8 sm:p-8 md:p-6 lg:p-8 gap-8 h-full col-span-5 md:col-span-3'>
        <OfferDetailsInModal
          content={{ offerDetails, handleOpenandCloseModal }}
        />
      </div>
    </section>
  );
}

export default ModalBuyorSellTransaction;
